import React from 'react'
import { useIntl } from 'react-intl'
import { Order } from '@src/types/graphql-types'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import messages from '../messages'
import ErrorCircleIcon from '@src/icons/ErrorCircleIcon'
import { renderOrderStatusText } from '../RenderStatusText'

const useStyles = makeStyles((theme: Theme) => ({
  orderStatus: {
    display: 'flex',
    flexDirection: 'column',
  },
  shippedText: {
    fontSize: theme.typography.pxToRem(12),
  },

  errorIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: theme.spacing(1),
  },
}))

interface OrderStatusProps {
  order: Order
  callback?: React.MouseEventHandler
}

const OrderStatus: React.FC<OrderStatusProps> = ({ order, callback }) => {
  const { formatMessage, formatNumber } = useIntl()
  const classes = useStyles()

  const statusText = renderOrderStatusText(order.statusAlias)

  if (!order.totalItems) return statusText

  return (
    <div className={classes.orderStatus}>
      <span>
        {(order.billingBlock || order.deliveryBlock) && (
          <ErrorCircleIcon
            className={classes.errorIcon}
            color="error"
            onMouseEnter={callback}
          />
        )}
        {statusText}
      </span>
      <span className={classes.shippedText}>
        {formatMessage(messages.X_OF_Y_SHIPPED, {
          x: formatNumber(order.totalCompletedItems || 0),
          y: formatNumber(order.totalItems || 0),
        })}
      </span>
    </div>
  )
}

export default OrderStatus
